import React from "react";
import Slider from "react-slick";
import "./PartnersSlides.css";

import nineLivesLogo from '../content/partnersLogos/9LivesLogo.png';
import naplandLogo from '../content/partnersLogos/NAPLandIcon.png';
import vngelLogo from '../content/partnersLogos/vngelLogo.png';
import nettechLogo from '../content/partnersLogos/nettechLogo.png'
import verticalGraphics from '../content/partnersLogos/VerticalGraphics.jpg'

const PartnersSlideshow = () => {
  const partners = [
    { id: 1, 
      logo: vngelLogo,
      link: "https://www.instagram.com/vngelforever/",
    },
    { id: 2, 
      logo: nettechLogo ,
      link: "https://www.nettechsa.com/",
    },
    { id: 3, logo: nineLivesLogo,
      link: "https://www.instagram.com/8plus1life/",
    },
    { id: 4, 
      logo: naplandLogo ,
      link: "https://www.instagram.com/nap.land/"
    },
    { id: 5,
      logo: verticalGraphics,
      link: "https://verticalgraphics.co.za/",
    }
  ];

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <div className="partners-slideshow">
      <h2 className="partners-title">Our Partners</h2>
      <Slider {...settings} className="partner-slider">
        {partners.map((partner) => (
          <div key={partner.id} className="partner-slide">
            <a href={partner.link}>
                <img src={partner.logo} alt={`Partner ${partner.id}`} />
            </a>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default PartnersSlideshow;
